import request from '@/util/request';
import qs from 'qs';

export const getMainList = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/page/v2', Object.assign({}, options, {
    params
  }));

export const getList = (params, options) =>
  request.get('/api/v4ward/car/carMonthDetail/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/save/v2', params, options);

export const addRenior = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/addRenior/v2', params, options);

export const copyCarmonth = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/copyRenior/v2',
    Object.assign({}, options, {
      params
    }));

export const update = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/update/v2', params, options);

export const getRuleDetail = (params, options) =>
  request.get('/api/v4ward/car/monthChangeRule/detail/v2', Object.assign({}, options, {
    params
  }));

export const carMonthList = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carMonthList/v2', Object.assign({}, options, {
    params
  }));

export const carMonthStartTime = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carMonthStartTime/v2', Object.assign({}, options, {
    params
  }));

export const getcarMonthLastEndTime = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/carMonthLastEndTime/v2',
    Object.assign({}, options, {
      params
    })
  );

export const updateStatus = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/update/v2',
    Object.assign({}, options, {
      params
    }));

export const getDetailAndOperate = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/detailAndOperate/v2', Object.assign({}, options, {
    params
  }));

export const synchronize = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/synchronize/v2', qs.stringify(params), options);

//车辆收费-欠费
export const loadCarPayBackAmount = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/carBackAmount/v2', Object.assign({}, options, {
    params
  }));

//车辆收费-收费金额
export const loadCarPayAmount = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/getPayMoney/v2', Object.assign({}, options, {
    params
  }));

//车辆收费-月卡车下拉框
export const loadCarPayMonthCarNo = (params, options) =>
  request.get('/api/park/vehicle/getParkVehicleList/v2', Object.assign({}, options, {
    params
  }));

//获取区域
export const nodeTreeByParentId = (parentId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId/v2',
    method: 'get',
    params: {
      parentId,
    },
  });
};

//查询临停欠费记录
export const getListTempStopUnPayList = (params, options) =>
  request.get('/api/v4ward/car/listTempStopUnPayList/v2', Object.assign({}, options, {
    params
  }));

export const listCarMonthByProperty = (params, options) =>
  request.get('/api/v4ward/car/CarMonth/listByProperty/v2', Object.assign({}, options, {
    params
  }));
//月卡车暂停
export const carMonthStop = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/stop/v2', params, options);
//月卡车重启
export const carMonthRestart = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/restart/v2', params, options);

export const exportMonthCarList = (formData) => {
  return request({
    url: '/api/v4ward/car/CarMonth/import/v2',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
  });

};
